import { render, staticRenderFns } from "./Editcourses.vue?vue&type=template&id=e24d2f2e"
import script from "./Editcourses.vue?vue&type=script&lang=js"
export * from "./Editcourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports